import { styled } from '@mui/material/styles';
import EditIcon from '@mui/icons-material/Edit';
import { ReactComponent as InfoIcn } from './../../assets/info.svg';
import TwField from './../../components/TwFields/TwFields';
import Alert from '@mui/material/Alert';

export const EditPencil = styled(EditIcon)(({ theme }) => ({
  color: '#6B7280',
  cursor: 'pointer'
}));

export const InfoIcon = styled(InfoIcn)(({ theme }) => ({
  height: '20px',
  width: '20px',
  marginTop: '20px'
}));

export const TwFieldCustom = styled(TwField)(({ theme }) => ({
  width: '180px'
}));

export const DriverAlertStyled = styled(Alert)({
  backgroundColor: '#F3F4F6',
  border: '1px solid #E5E7EB',
  fontFamily: 'Poppins',
  fontSize: '14px',
  fontWeight: '400',
  color: '#1F2937',
  display: 'flex',
  alignItems: 'center',

  '& .MuiAlert-message': {
    padding: '0px'
  }
});
